import { UseCaseInteractor } from '../../../kernel/use-case'
import { GetResouceOutput } from '../domain/entities'
import { ReAssignaDataRepository } from '../domain/re-assign-data.repository'
import { BaseSearchCriteria } from '../../../kernel/base-entities'

export const getResoucesCanTakeTaskUseCase: UseCaseInteractor<
  [ReAssignaDataRepository],
  [taskId: string, quotaless: boolean, filters: BaseSearchCriteria],
  GetResouceOutput
> = (reAssignaDataRepository) => async (taskId, quotaless, filters) => {
  return reAssignaDataRepository.getResoucesCanTakeTask(taskId, quotaless, filters)
}
